import React from 'react';
import {
  ABody,
  ABodySize,
  AIcon,
  AIconSize,
  MButton,
  MButtonType,
  MButtonSize,
  MButtonIconPlacement,
} from '@marriott/mi-web-ui-kit';
import { AI_SEARCH_TRACK_LABELS } from '../../constants/aiSearchTrackLabels';
import * as Styled from './MErrorMessage.styles';
import { MErrorMessageProps } from './MErrorMessage.types';

export const MErrorMessage: React.FC<MErrorMessageProps> = ({ uiData, onRetry }) => {
  const errorText = uiData?.errorText || 'Something went wrong.';
  const originalMessage = uiData?.originalMessage || '';
  const errorMessageId = uiData?.errorMessageId || '';
  const resolvedVariant = uiData?.variant ?? 'error';
  const isInfoVariant = resolvedVariant === 'info';

  const handleRetry = () => {
    if (onRetry && originalMessage && errorMessageId) {
      onRetry(originalMessage, errorMessageId);
    }
  };

  return (
    <Styled.Container $variant={resolvedVariant}>
      <Styled.IconWrapper $variant={resolvedVariant}>
        <AIcon
          icon={isInfoVariant ? 'icon-information' : 'icon-warning'}
          size={AIconSize.S}
          aria-label={isInfoVariant ? 'Information' : 'Error'}
        />
      </Styled.IconWrapper>
      <Styled.TextWrapper $variant={resolvedVariant} data-track-label={AI_SEARCH_TRACK_LABELS.TRY_AGAIN_ERROR_MESSAGE}>
        <ABody bodyText={errorText} size={ABodySize.S} />
        {originalMessage && errorMessageId && onRetry && (
          <Styled.ButtonWrapper>
            <MButton
              variant={MButtonType.Tertiary}
              size={MButtonSize.S}
              iconPlacement={MButtonIconPlacement.Trailing}
              aIcon={{ icon: 'icon-renew' }}
              onClick={handleRetry}
              aria-label="Retry sending message"
              data-track-label={AI_SEARCH_TRACK_LABELS.TRY_AGAIN_CTA}
            >
              Try again
            </MButton>
          </Styled.ButtonWrapper>
        )}
      </Styled.TextWrapper>
    </Styled.Container>
  );
};

export type { MErrorMessageProps, MErrorMessageUiData, MErrorMessageVariant } from './MErrorMessage.types';
